export const getPaymentInput = ({ payment, id }, { allowMissingPayment = false } = {}) => {
    if (!payment) {
        if (!allowMissingPayment)
            throw new Error(`No payment type on contract: ${id}`);
        return {
            provider: "custom",
            custom: { properties: [] },
        };
    }
    if (payment.__typename !== "CustomPayment")
        throw new Error(`Payment ${payment.__typename} method not supported on contract: ${id}`);
    return {
        provider: payment.provider,
        custom: { properties: payment.properties },
    };
};
